/**
 * Module-level holder for the surface's EFFECTIVE attribution campaign —
 * the campaign_code the resolve endpoint returned (system campaign, or a
 * blessed host override). Set once by InstanceProvider when config lands;
 * read by checkoutApi so every booking init carries it without threading
 * React context through plain API modules. Server-side, a user's
 * first-touch claim still wins over this.
 */
let effectiveCampaign: string | null = null;

export function setEffectiveCampaign(code: string | null | undefined): void {
  effectiveCampaign = code || null;
}

export function getEffectiveCampaign(): string | null {
  return effectiveCampaign;
}
